/* eslint-disable react/self-closing-comp,no-script-url */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import './Footer.scss';

const Footer = () => {
  const openSubscribeWindow = () => {
    window.location.href = 'https://form.jotform.com/232210347883555';
  };
  return (
    <>
      <footer
        id="footer-wrapper"
        style={{
          background: 'http://html.inspirydemos.com/knowledgebase-html/images/footer-bg.png',
        }}
      >
        <div id="footer" className="container">
          <div className="row">
            <div className="col-md-4">
              <section className="widget">
                <h3>How it works</h3>
                <div className="d-flex flex-column gap-2">
                  <a
                    href="/documents/how-it-works.pdf"
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-none"
                  >
                    Project Description
                  </a>
                  <a
                    href="https://www.youtube.com/watch?v=22GPBNxNmwg"
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-none"
                  >
                    Video Tutorials
                  </a>
                  <a
                    href="/documents/terms-of-use.pdf"
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-none"
                  >
                    Terms of Use
                  </a>
                  <br />
                  <br />
                  <h5>
                    <a
                      href="https://avraonline.com"
                      className="text-decoration-none"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Partners
                    </a>
                  </h5>
                  <h5>
                    <a
                      href="https://avraonline.com"
                      className="text-decoration-none"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Collaborators
                    </a>
                  </h5>
                  <h5>
                    <a
                      href="https://avraonline.com/index.php/contact/"
                      className="text-decoration-none"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Contact us
                    </a>
                  </h5>
                </div>
              </section>
            </div>
            <div className="col-md-3">
              <section className="widget d-flex">
                <div className="news-letter">
                  <span>
                    Subscribe to our news letter
                    <br />
                    Get stories and courses directly into your mailbox
                  </span>
                  <button type="button" onClick={openSubscribeWindow}>
                    Join now [Opens in a new window]
                  </button>
                </div>
              </section>
            </div>
            <div className="col-md-5">
              <section className="widget d-flex flex-column justify-content-end align-items-end">
                <h3 className="title text-center w-100">Stay Connected</h3>
                <div className="textwidget w-100">
                  <div className="d-flex gap-3 mt-3 justify-content-center">
                    <a href="https://facebook.com/KnowledgeCube1" target="_blank" rel="noreferrer">
                      <i className="fa fa-facebook" />
                    </a>
                    <a href="https://www.youtube.com/@KnowledgeCube-wj1il" target="_blank" rel="noreferrer">
                      <i className="fa fa-youtube" />
                    </a>
                    <a href="https://www.linkedin.com/in/osamaelrawi/" target="_blank" rel="noreferrer">
                      <i className="fa fa-linkedin" />
                    </a>
                  </div>
                </div>
              </section>
            </div>

          </div>
        </div>

        <div id="footer-bottom-wrapper">
          <div id="footer-bottom" className="container">
            <div className="row">
              <div className="span6">
                <p className="copyright text-white">
                  Copyright © 2023. All Rights Reserved by
                  {' '}
                  <a
                    href="https://avraonline.com"
                    className="creator-link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    AVRA
                  </a>
                  .
                </p>
              </div>
              <div className="span6">
                <ul className="social-nav clearfix">
                  <li className="linkedin"><a target="_blank" href="#"></a></li>
                  <li className="stumble"><a target="_blank" href="#"></a></li>
                  <li className="google"><a target="_blank" href="#"></a></li>
                  <li className="deviantart"><a target="_blank" href="#"></a></li>
                  <li className="flickr"><a target="_blank" href="#"></a></li>
                  <li className="skype"><a target="_blank" href="#"></a></li>
                  <li className="rss"><a target="_blank" href="#"></a></li>
                  <li className="twitter"><a target="_blank" href="#"></a></li>
                  <li className="facebook"><a target="_blank" href="#"></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <a href="#top" id="scroll-top"></a>
    </>
  );
};

export default Footer;
